export const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1)

// Mirrors Ruby's String#squish: strips leading/trailing whitespace and collapses extra whitespace to a single space.
export const squish = (text) => text?.trim().replace(/\s+/g, " ")

export const snakeToCapitalCase = (text) => text
  .split("_")
  .map(capitalize)
  .join(" ")

export const snakeTolowerCase = (text) => text
  .split("_")
  .join(" ")

export const kebabCaseToCamelCase = (text) => text.toLowerCase().split("-").reduce((camel, word, index) => (
  index === 0
    ? word
    : `${camel}${capitalize(word)}`
), "")

const FILENAME_ILLEGAL_CHARS = /[/\\?%*:|"<>]/g
export const sanitizeFilename = (filename) => filename.replaceAll(" ", "").replace(FILENAME_ILLEGAL_CHARS, "-")

export const escapeHtml = (text) => text
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#039;")
